
export class AuditCollectDelayModel {
  collectAuditTimeMax: string;
  collectAuditTimeMin: string;
  collectAuditTimeAvg: string;
}
